/* Bag offer: one tap adds another heated wrap in the chosen colour. The
   bundle saving is an automatic discount in Shopify, so the price drops on
   its own once the bag qualifies. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-one]');
    if (!b || !window.latigoCart) return;
    e.preventDefault();
    b.disabled = true;
    window.latigoCart.add(b.getAttribute('data-add-one'), 1);
    if (document.body.classList.contains('template-cart')) {
      setTimeout(function () { window.location.reload(); }, 1400);
    }
  });

  /* Bundle picker: the bundle chosen sets how many wraps and power banks
     are added. "1 wrap" offers the power bank as a tick box; "2 wraps + 2
     power banks" always adds two in the colour picked. */
  function syncBundle(form) {
    var r = form.querySelector('[data-bundle] input[name="bundle"]:checked');
    if (!r) return;
    var qty = form.querySelector('[data-qty-input]');
    if (qty) qty.value = r.getAttribute('data-qty') || r.value;

    var box = form.querySelector('[data-addon]');
    if (!box) return;
    var mode = r.getAttribute('data-addon-qty');
    var toggle = box.querySelector('[data-addon-toggle]');
    var n = mode === 'opt' ? (toggle && toggle.checked ? 1 : 0) : parseInt(mode, 10) || 0;
    box.hidden = mode === '0';
    box.querySelector('[data-addon-opt]').hidden = mode !== 'opt';
    box.querySelector('[data-addon-duo]').hidden = mode === 'opt';
    box.querySelector('[data-addon-colours]').hidden = n === 0;
    var extra = box.querySelector('[data-extra]');
    var colour = box.querySelector('input[name="addon-colour"]:checked');
    if (colour) extra.value = colour.value;
    extra.setAttribute('data-extra-qty', String(n));
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest('[data-bundle]')) return;
    var form = e.target.closest('form');
    if (form) syncBundle(form);
  });

  document.querySelectorAll('[data-bundle]').forEach(function (b) {
    var form = b.closest('form');
    if (form) syncBundle(form);
  });
})();
